import { Component, Output, EventEmitter,Input, OnInit, ElementRef, ViewChild, OnDestroy, SimpleChanges} from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'cargoes-freetext-component',
    template: `
      <nz-input-group [nzSuffix]="suffixIconSearch" class="mob-mb-md">
        <input type="text" nz-input placeholder="{{placeholder | translate}}" (input)="search($event)" #searchInput>
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i nz-icon nzType="search"></i>
      </ng-template>
    `
})
export class SearchFreeTextComponent implements OnInit, OnDestroy{
    @ViewChild('searchInput') searchInput!: ElementRef;
    @Input() placeholder="app.label.search";
    @Input() clear!: Observable<void>;
    @Input() value!: string;
    private clearSubscription!: Subscription;
    @Output() onSearch = new EventEmitter<any>();
    debouncer: Subject<string> = new Subject();

    constructor() {
      this.debouncer.pipe(debounceTime(300),distinctUntilChanged()).subscribe((data)=>{
        this.onSearch.emit(data);
      });
    }

    ngOnInit(): void {
      if(this.clear){
        this.clearSubscription = this.clear.subscribe((data)=>{
          this.searchInput.nativeElement.value = '';
          this.debouncer.next('');
        });
      }
    }

    search($event:any) {
      this.debouncer.next($event.target.value);
    }

     ngOnChanges(changes: SimpleChanges): void {
      if (changes['value'] && this.searchInput) {
        this.searchInput.nativeElement.value = this.value || '';
      }
    }

    ngOnDestroy(): void {
      if(this.clearSubscription)
      this.clearSubscription.unsubscribe();
    }
}
